/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { DynamicIconHelper } from '@mpb-com/feather/components/atoms/dynamic-icon-helper';
import {
    Icon,
    IconSize,
    IconVariant,
} from '@mpb-com/feather/components/atoms/icon';
import React, { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import FacebookHover from '@toucan/client/global/icons/facebook-hover.svg';
import Facebook from '@toucan/client/global/icons/facebook.svg';
import InstagramHover from '@toucan/client/global/icons/instagram-active.svg';
import Instagram from '@toucan/client/global/icons/instagram.svg';
// eslint-disable-next-line id-length -- Legacy code: do not use as an example.
import X from '@toucan/client/global/icons/x-formally-known-as-twitter.svg';
import YoutubeHover from '@toucan/client/global/icons/youtube-active.svg';
import Youtube from '@toucan/client/global/icons/youtube.svg';

import { MarketContext } from '@toucan/client/global/market';

import {
    Link,
    LinkTarget,
    LinkVariant,
} from '@toucan/client/shared/components/link';

import { getSocialChannelLinks } from './helpers';
import { styles } from './social-channels.styles';
import { SocialChannelsProps } from './types';

const socialIcons = {
    facebook: {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        Resting: Facebook,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        Hover: FacebookHover,
    },
    instagram: {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        Resting: Instagram,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        Hover: InstagramHover,
    },
    twitter: {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        Resting: X,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        Hover: X,
    },
    youtube: {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        Resting: Youtube,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        Hover: YoutubeHover,
    },
};

const StyledSocialChannels = styled('ul').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const SocialChannels: FunctionComponent<SocialChannelsProps> = ({
    items = ['facebook', 'instagram', 'twitter', 'youtube'],
    ...otherProps
}: SocialChannelsProps) => {
    const { activeMarket } = useContext(MarketContext);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const socialChannelUrls = getSocialChannelLinks(activeMarket.language);
    return (
        <StyledSocialChannels {...otherProps}>
            {items.map((item) => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
                const { Resting, Hover } = socialIcons[item];
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
                const url = socialChannelUrls[item];

                return (
                    <li key={item}>
                        <Link
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
                            href={url}
                            target={LinkTarget.BLANK}
                            rel="noopener noreferrer"
                            variant={LinkVariant.CUSTOM}
                            aria-label={item}
                        >
                            <Icon
                                aria-hidden="true"
                                size={IconSize.M}
                                variant={IconVariant.ACTIONABLE}
                            >
                                <DynamicIconHelper
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
                                    resting={Resting}
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
                                    hover={Hover}
                                />
                            </Icon>
                        </Link>
                    </li>
                );
            })}
        </StyledSocialChannels>
    );
};
